import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { placesSlice } from "@common/redux/slices/entities.slice";
import { IPlace } from "@common/redux/types/places";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { EntityCard } from "@kursk/components/ui/EntityCard/EntityCard";
import { getCardTypeByIdx } from "@kursk/utils/getCardTypeByIdx";
import { useOrientations } from "@common/hooks/useOrientation";
import { useCallback } from "react";

export function PlacesGrid() {
  const { items, total, offset } = useSelectSlice(placesSlice);
  const orientation = useOrientations()
  const getCardType = useCallback((index) => {
    return getCardTypeByIdx(index, orientation)
  }, [orientation])

  return (
    <EntitiesGrid
      <IPlace>
      entityType="places"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: IPlace, index) => <EntityCard key={item._id} type={getCardType(index)}
        entityType="places" entity={item}/>}
    />
  );
}
